import { Position } from './Position';
import type { EventProps } from './types';

export const hotjarTracking = ({
  emitter,
  hotjarTracking,
}: Omit<EventProps, 'trackClick'>): void => {
  const { tagRecording, trigger } = hotjarTracking;

  //#region top bar top level
  emitter.on('clickedLogo', (event) => {
    if (event.position !== Position.primaryNavigation) {
      return;
    }

    tagRecording('Clicked: Logo - Primary navigation');
    trigger('clicked_logo_primary_nav');
  });

  emitter.on('clickedInviteMembers', (event) => {
    if (event.position === Position.primaryNavigation) {
      tagRecording('Clicked: Invite team members icon - Primary navigation');
      trigger('clicked_invite_members_icon_primary_nav');
    }

    if (event.position === Position.accountMenu) {
      tagRecording('Clicked: Invite team members - Account menu - Primary navigation');
      trigger('clicked_invite_members_account_primary_nav');
    }
  });
  //#endregion

  //#region site selector
  emitter.on('clickedSiteSelector', (event) => {
    if (event.position !== Position.primaryNavigation) {
      return;
    }

    tagRecording('Clicked: Site selector - Primary navigation');
    trigger('clicked_site_selector_primary_nav');
  });

  // not needed. It's here so the sync script doesn't break
  emitter.on('focusedSiteSelectorSearch', (event) => {
    if (event.position !== Position.siteSelector) {
      return;
    }

    tagRecording('Focused: Site selector - Primary navigation');
    trigger('focused_site_selector_primary_nav');
  });

  // not needed. It's here so the sync script doesn't break
  emitter.on('searchedSites', (event) => {
    if (event.position !== Position.siteSelector) {
      return;
    }

    tagRecording('Searched: Site selector - Primary navigation');
    trigger('searched_site_selector_primary_nav');
  });

  // not needed. It's here so the sync script doesn't break
  emitter.on('selectedSite', (event) => {
    if (event.position !== Position.siteSelector) {
      return;
    }

    tagRecording('Selected: Site selector - Primary navigation');
    trigger('selected_site_selector_primary_nav');
  });

  emitter.on('clickedAddNewSite', (event) => {
    if (event.position !== Position.siteSelector) {
      return;
    }

    tagRecording('Clicked: Add new site - Primary navigation');
    trigger('clicked_add_new_site_primary_nav');
  });
  //#endregion

  //#region help menu
  emitter.on('clickedHelpMenu', (event) => {
    if (event.position !== Position.primaryNavigation) {
      return;
    }

    tagRecording('Clicked: Help icon - Primary navigation');
    trigger('clicked_help_icon_primary_nav');
  });

  emitter.on('clickedGetHelp', (event) => {
    if (event.position !== Position.helpMenu) {
      return;
    }

    tagRecording('Clicked: Get Help - Primary navigation');
    trigger('clicked_get_help_primary_nav');
  });

  emitter.on('clickedGSGItem', (event) => {
    if (event.position !== Position.primaryNavigation) {
      return;
    }

    tagRecording('Clicked: GSG Item - Primary navigation');
    trigger('clicked_gsg_item');
  });

  emitter.on('clickedBrowseGuides', (event) => {
    if (event.position !== Position.helpMenu) {
      return;
    }

    tagRecording('Clicked: Browse guides - Primary navigation');
    trigger('clicked_browse_guides_primary_nav');
  });

  emitter.on('clickedExploreCourses', (event) => {
    if (event.position !== Position.helpMenu) {
      return;
    }

    tagRecording('Clicked: Explore courses - Primary navigation');
    trigger('clicked_explore_courses_primary_nav');
  });

  emitter.on('clickedProductUpdates', (event) => {
    if (event.position !== Position.helpMenu) {
      return;
    }

    tagRecording('Clicked: Product updates - Primary navigation');
    trigger('clicked_product_updates_primary_nav');
  });

  emitter.on('clickedSystemStatus', (event) => {
    if (event.position !== Position.helpMenu) {
      return;
    }

    tagRecording('Clicked: System status - Primary navigation');
    trigger('clicked_system_status_primary_nav');
  });
  //#endregion

  //#region account menu
  emitter.on('clickedAccountMenu', (event) => {
    if (event.position !== Position.primaryNavigation) {
      return;
    }

    tagRecording('Clicked: Account - Primary navigation');
    trigger('clicked_account_primary_nav');
  });

  emitter.on('clickedProfileSummary', (event) => {
    if (event.position !== Position.accountMenu) {
      return;
    }

    tagRecording('Clicked: Profile summary - Primary navigation');
    trigger('clicked_profile_summary_primary_nav');
  });

  emitter.on('clickedViewProfile', (event) => {
    if (event.position !== Position.accountMenu) {
      return;
    }

    tagRecording('Clicked: View profile - Primary navigation');
    trigger('clicked_view_profile_primary_nav');
  });

  emitter.on('clickedAccountSettings', (event) => {
    if (event.position !== Position.accountMenu) {
      return;
    }

    tagRecording('Clicked: Account settings - Primary navigation');
    trigger('clicked_account_settings_primary_nav');
  });

  emitter.on('clickedBilling', (event) => {
    if (event.position !== Position.accountMenu) {
      return;
    }

    tagRecording('Clicked: Billing - Primary navigation');
    trigger('clicked_billing_primary_nav');
  });

  emitter.on('clickedLogout', (event) => {
    if (event.position !== Position.accountMenu) {
      return;
    }

    tagRecording('Clicked: Logout - Primary navigation');
    trigger('clicked_logout_primary_nav');
  });
  //#endregion

  //#region nav toolbar
  emitter.on('clickedSidebarExpand', (event) => {
    if (event.position !== Position.navToolbar) {
      return;
    }

    tagRecording('Clicked: Expand - Nav Toolbar');
    trigger('clicked_expand_nav_toolbar');
  });

  emitter.on('clickedSidebarCollapse', (event) => {
    if (event.position !== Position.navToolbar) {
      return;
    }

    tagRecording('Clicked: Collapse - Nav Toolbar');
    trigger('clicked_collapse_nav_toolbar');
  });

  emitter.on('clickedOverview', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Space Overview - Nav toolbar - Tools');
    trigger('clicked_space_overview_nav_toolbar');
  });

  emitter.on('clickedDashboardQuantz', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Quantitative dashboard - Nav toolbar - Tools');
    trigger('clicked_quantitative_dashboard_nav_toolbar');
  });

  emitter.on('clickedHighlights', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Highlights - Nav toolbar - Tools');
    trigger('clicked_highlights_nav_toolbar');
  });

  emitter.on('clickedTrends', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Trends - Nav toolbar - Tools');
    trigger('clicked_trends_nav_toolbar');
  });

  emitter.on('clickedRecordings', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Recordings - Nav toolbar - Tools');
    trigger('clicked_recordings_nav_toolbar');
  });

  emitter.on('clickedHeatmaps', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Heatmaps - Nav toolbar - Tools');
    trigger('clicked_heatmaps_nav_toolbar');
  });

  emitter.on('clickedFeedback', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Feedback - Nav toolbar - Tools');
    trigger('clicked_feedback_nav_toolbar');
  });

  emitter.on('clickedSurveys', (event) => {
    if (event.position !== Position.toolsToolbar) {
      return;
    }

    tagRecording('Clicked: Surveys - Nav toolbar - Tools');
    trigger('clicked_surveys_nav_toolbar');
  });

  emitter.on('clickedOrgsAndSites', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Organizations and Sites - Nav toolbar - Account settings');
    trigger('clicked_organizations_and_sites_nav_toolbar');
  });

  emitter.on('clickedTeam', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Team - Nav toolbar - Account settings');
    trigger('clicked_team_nav_toolbar');
  });

  emitter.on('clickedUserAttributes', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: User attributes - Nav toolbar - Account settings');
    trigger('clicked_user_attributes_nav_toolbar');
  });

  emitter.on('clickedIntegrations', (event) => {
    if (event.position === Position.primaryNavigation) {
      // Top bar icon
      tagRecording('Clicked: Integrations icon - Primary navigation');
      trigger('clicked_integrations_icon_primary_nav');
    } else if (event.position === Position.accountMenu) {
      // Account menu
      tagRecording('Clicked: Integrations - Primary navigation');
      trigger('clicked_integrations_primary_nav');
    } else if (event.position === Position.accountSettingsToolbar) {
      // Side bar - Settings page
      tagRecording('Clicked: Integrations - Nav toolbar - Account settings');
      trigger('clicked_integrations_nav_toolbar');
    }
  });

  emitter.on('clickedUserLookup', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: User lookup - Nav toolbar - Account settings');
    trigger('clicked_user_lookup_nav_toolbar');
  });

  emitter.on('clickedSSO', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: SSO - Nav toolbar - Account settings');
    trigger('clicked_sso_nav_toolbar');
  });

  emitter.on('clickedPlansBilling', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Nav toolbar - Account settings');
    trigger('clicked_plans_and_billing_nav_toolbar');
  });

  emitter.on('clickedSubscriptions', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Nav toolbar - Account settings');
    trigger('clicked_subscriptions_nav_toolbar');
  });

  emitter.on('clickedInvoices', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Invoices - Nav toolbar - Account settings');
    trigger('clicked_invoices_nav_toolbar');
  });

  emitter.on('clickedPreferences', (event) => {
    if (event.position !== Position.accountSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Preferences - Nav toolbar - Account settings');
    trigger('clicked_preferences_nav_toolbar');
  });

  emitter.on('clickedMyDetails', (event) => {
    if (event.position !== Position.profileSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: My Details - Nav toolbar - Profile settings');
    trigger('clicked_my_details_nav_toolbar');
  });

  emitter.on('clickedNotifications', (event) => {
    if (event.position !== Position.profileSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Notifications - Nav toolbar - Profile settings');
    trigger('clicked_notifications_nav_toolbar');
  });

  emitter.on('clickedReferAndEarn', (event) => {
    if (event.position !== Position.profileSettingsToolbar) {
      return;
    }

    tagRecording('Clicked: Refer and Earn - Nav toolbar - Profile settings');
    trigger('clicked_refer_and_earn_nav_toolbar');
  });
  //#endregion
};
